import React, { useReducer, useEffect, Suspense } from "react";
import { Redirect, Route, Switch, BrowserRouter } from "react-router-dom";

// import context
import { AuthContext } from "./context/Auth";
import { CartContext } from "./context/Cart";

// import reducers
import AuthReducer, { logIn } from "./store/Auth";
import CartReducer from "./store/Cart";
import { initState, cartInitState } from "./store/initState";

// admin pages
// import AdminDashboard from "./pages/Admin/AdminDashborad";

// common pages
// import ThankYou from "./pages/ThankYou";
import Reports from "./pages/Reports";
// import Developer from "./pages/Developer";
import HomeLoggedOut from "./pages/HomeLoggedOut";
import Navbar from "./components/Common/Navbar";
import HomeLoggedIn from "./pages/HomeLoggedIn";

// api services
import { getCartItems } from "./services/cartService";
import { setItems } from "./store/Cart";
import CustomLoading from "./components/Common/CustomLoading";

// const HomeLoggedOut = React.lazy(() => import("./pages/HomeLoggedOut"));
// const HomeLoggedIn = React.lazy(() => import("./pages/HomeLoggedIn"));

// import ShowBooks from "./pages/ShowBooks";
// import BookDetails from "./pages/BookDetails";
// import BooksByCategory from "./pages/BooksByCategory";

// import Login from "./pages/Login";
// import Signup from "./pages/Signup";
// import ForgotPassword from "./pages/ForgotPassword";
// import ResetPassword from "./pages/ResetPassword";

const AdminDashboard = React.lazy(() => import("./pages/Admin/AdminDashborad"));
const Developer = React.lazy(() => import("./pages/Developer"));
const ThankYou = React.lazy(() => import("./pages/ThankYou"));

// auth pages
const Login = React.lazy(() => import("./pages/Login"));
const Signup = React.lazy(() => import("./pages/Signup"));
const ForgotPassword = React.lazy(() => import("./pages/ForgotPassword"));
const ResetPassword = React.lazy(() => import("./pages/ResetPassword"));

// account pages
// import EditProfile from "./pages/EditProfile";
// import PreviewProfile from "./pages/PreviewProfile";
// import UpdatePassword from "./pages/UpdatePassword";
const EditProfile = React.lazy(() => import("./pages/EditProfile"));
const PreviewProfile = React.lazy(() => import("./pages/PreviewProfile"));
const UpdatePassword = React.lazy(() => import("./pages/UpdatePassword"));

// books pages
const ShowBooks = React.lazy(() => import("./pages/ShowBooks"));
const BookDetails = React.lazy(() => import("./pages/BookDetails"));
const BooksByCategory = React.lazy(() => import("./pages/BooksByCategory"));

// cart pages
// import Cart from "./pages/Cart";
const Cart = React.lazy(() => import("./pages/Cart"));

// orders pages
// import MyOrders from "./pages/MyOrders";
// import NewOrder from "./pages/NewOrder";
const MyOrders = React.lazy(() => import("./pages/MyOrders"));
const NewOrder = React.lazy(() => import("./pages/NewOrder"));

function App() {
  const [authState, authDispatch] = useReducer(AuthReducer, initState);
  const [cartState, cartDispatch] = useReducer(CartReducer, cartInitState);

  const fetchCartItems = async (token) => {
    const cartItems = await getCartItems(token);
    cartDispatch(setItems(cartItems.data.cart.items));
  };

  // const getMyInfo = async (token) => {
  //   const { data } = await fetchMe(token);
  //   authDispatch(logIn(token, data.data));
  // };

  useEffect(() => {
    let user = JSON.parse(localStorage.getItem("user"));
    let token = JSON.parse(localStorage.getItem("token"));

    if (!user || !token) return;

    authDispatch(logIn(token, user));

    fetchCartItems(token);
    // getMyInfo(token);
  }, []);

  return (
    <div className="App">
      <AuthContext.Provider
        value={{
          authState,
          authDispatch,
        }}
      >
        <CartContext.Provider
          value={{
            cartState,
            cartDispatch,
          }}
        >
          <BrowserRouter>
            <Navbar />

            <Switch>
              <Suspense fallback={<CustomLoading />}>
                <Route
                  exact
                  path="/books"
                  render={() => (
                    <ShowBooks
                      booksWrapperClass="show-books"
                      wrapperClass="wrapper m-t-h"
                    />
                  )}
                />
                <Route path="/reports/new" component={Reports} />
                <Route path="/developer" component={Developer} />

                {!authState.isLogedIn && (
                  <>
                    <Route path="/" exact render={() => <HomeLoggedOut />} />
                    <Route path="/books/:id" exact component={BookDetails} />

                    <Route path="/login" component={Login} />
                    <Route path="/signup" component={Signup} />
                    <Route path="/resetPassword/:token" exact component={ResetPassword} />
                    <Route path="/forgotpassword" component={ForgotPassword} />
                    <Route
                      path="/done"
                      exact
                      render={() => (
                        <ThankYou
                          title="Passwrd Reset Email was Sent Successfully"
                          btnLink="/login"
                          btnText="Login"
                        />
                      )}
                    />
                  </>
                )}

                {authState.isLogedIn && (
                  <>
                    <Route path="/" exact component={HomeLoggedIn} />
                    <Route
                      path="/show-books/:category"
                      exact
                      component={BooksByCategory}
                    />
                    <Route path="/books/:id" exact component={BookDetails} />

                    <Route path="/edit-profile" component={EditProfile} />
                    <Route path="/view-profile" component={PreviewProfile} />
                    <Route path="/update-password" component={UpdatePassword} />

                    <Route path="/cart" exact component={Cart} />
                    <Route path="/orders/new" exact component={NewOrder} />
                    <Route
                      path="/thankyou"
                      exact
                      render={() => (
                        <ThankYou
                          title="Your Order was Sent Successfully"
                          btnText="Browse Prodcuts"
                          btnLink="/books"
                        />
                      )}
                    />
                    <Route path="/orders/me" component={MyOrders} />

                    {(authState.isLogedIn && authState.user.role === "admin") ||
                    authState.user.role === "manager" ? (
                      <Route path="/manage-app" component={AdminDashboard} />
                    ) : null}
                  </>
                )}
                {/* <Redirect from="/books" to="/" /> */}
              </Suspense>
            </Switch>
          </BrowserRouter>
        </CartContext.Provider>
      </AuthContext.Provider>
    </div>
  );
}

export default React.memo(App);
